import React from "react";
import { isEmpty } from "lodash";
import { FormattedMessage } from "react-intl";
import { ToastContainer, ToastBodySuccess, ToastBodyError } from "./styles";
import { messages } from "./messages";

interface Props {
  show: boolean;
  type: "success" | "error" | "updateError" | undefined;
  onClose: () => void;
  successfulMessage?: Record<string, string>;
}

const SuccessMessage = (successfulMessage?: Record<string, string>): JSX.Element => {
  const message = !isEmpty(successfulMessage) ? successfulMessage : messages.successful;
  return (
    <ToastBodySuccess>
      <FormattedMessage {...message} />
    </ToastBodySuccess>
  );
}

const ErrorMessage = (): JSX.Element => (
  <ToastBodyError>
    <FormattedMessage {...messages.error} />
  </ToastBodyError>
);

const UpdateErrorMessage = (): JSX.Element => (
  <ToastBodyError>
    <FormattedMessage {...messages.updateError} />
  </ToastBodyError>
);

export const CustomToast = ({ show, type, onClose, successfulMessage }: Props): JSX.Element => (
  <ToastContainer show={show} onClose={onClose} animation autohide delay={3000}>
    {type === "success" && <SuccessMessage {...successfulMessage} />}
    {type === "error" && <ErrorMessage />}
    {type === "updateError" && <UpdateErrorMessage />}
  </ToastContainer>
);
